/* eslint-disable unicorn/prefer-export-from */

import { InitOptions } from 'i18next';

import about from '../../public/locales/en/about.json';
import auth from '../../public/locales/en/auth.json';
import calendar from '../../public/locales/en/calendar.json';
import calendar_events from '../../public/locales/en/calendar_events.json';
import collaboration from '../../public/locales/en/collaboration.json';
import common from '../../public/locales/en/common.json';
import filters from '../../public/locales/en/filters.json';
import help from '../../public/locales/en/help.json';
import landing from '../../public/locales/en/landing.json';
import payments from '../../public/locales/en/payments.json';
import status from '../../public/locales/en/status.json';
import user_cabinet from '../../public/locales/en/user_cabinet.json';
//
import { languageCodes, languageDefaultCode } from './languages';

export const resources = {
    en: {
        about,
        auth,
        calendar,
        calendar_events,
        common,
        landing,
        help,
        user_cabinet,
        collaboration,
        filters,
        payments,
        status,
    },
};

export const optionsBase: InitOptions = {
    fallbackLng: languageDefaultCode,
    supportedLngs: languageCodes,
    defaultNS: 'common' satisfies keyof (typeof resources)['en'],
};
